import { useQuery } from '@/hooks/query.hook';
import NotificationManagement from '../notification-management/notification-management';
import { NotificationPermissionMode } from '@/enums/mode.enum';
import NotificationCreateWebApp from '../notification-management/notification-create-webapp';
import NotificationCreateEmail from '../notification-management/notifcation-create-email';

export default function NotificationManagementPermission() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case NotificationPermissionMode.CREATEWEBAPP:
      case NotificationPermissionMode.EDITWEBAPP:
        return <NotificationCreateWebApp />;
      case NotificationPermissionMode.CREATEEMAIL:
      case NotificationPermissionMode.EDITEMAIL:
        return <NotificationCreateEmail />;
      default:
        return <NotificationManagement />;
    }
  };
  return <>{renderContent()}</>;
}
